import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "fr", setLang: () => {}, tr: (s) => s });
export const useLang = () => useContext(LangContext);

const EN = {
  // nav / footer
  "Philosophie": "Philosophy",
  "Formations": "Trainings",
  "Galerie": "Gallery",
  "L'école": "The school",
  "Témoignages": "Testimonials",
  "Presse": "Press",
  "Certification": "Certification",
  "Contact": "Contact",
  "FAQ": "FAQ",
  "Espace école": "School dashboard",
  "Mon espace": "My space",
  "Connexion": "Log in",
  "Réserver une formation": "Book a training",
  "Menu": "Menu",
  "Accueil": "Home",
  "Explorer": "Explore",
  "Cursus": "Curriculum",
  "janzu.fr — site officiel": "janzu.fr — official website",
  "Presse & reportage TF1": "Press & TF1 report",
  "Certification Qualiopi": "Qualiopi certification",
  "Ambassadeurs": "Ambassadors",
  "Médias": "Media",
  "Communauté OJANZU": "OJANZU Community",
  "Les Ambassadeurs de l'école": "The School's Ambassadors",
  "Ils pratiquent, ils transmettent": "They practice, they pass it on",
  "En bassin — eau chaude": "In the pool — warm water",
  "En mer — lagon turquoise": "In the sea — turquoise lagoon",
  "Devenir ambassadeur·rice": "Become an ambassador",
  "Rejoindre une formation": "Join a training",
  "Témoignage vidéo — Instagram": "Video testimonial — Instagram",
  "La magie de l'eau, en images.": "The magic of water, in images.",
  "Un instant de séance partagé sur notre Instagram : l'eau qui porte, le lâcher-prise, la présence. Suivez @ojanzu pour vivre le quotidien de l'école.": "A session moment shared on our Instagram: water that carries you, letting go, presence. Follow @ojanzu to follow the school's daily life.",
  "Voir le réel sur Instagram": "Watch the reel on Instagram",
  "Au podcast": "Podcast",
  "Les formations en vidéo": "The trainings in video",
  "Quelques images de nos séances et de nos bassins — l'expérience Janzu en un coup d'œil.": "A few images from our sessions and pools — the Janzu experience at a glance.",
  "Dans la presse": "In the press",
  "Le Point — 20 octobre 2023 — Par Camille Renaud": "Le Point — October 20, 2023 — By Camille Renaud",
  "Lire l'article original sur lepoint.fr": "Read the original article on lepoint.fr",
  "Lire l'article": "Read the article",
  "Découvrir": "Discover",
  "La galerie vidéo": "The video gallery",
  "Quelques instants filmés — en bassin, en mer, sous le soleil. Lancez la lecture, laissez l'eau faire le reste.": "A few filmed moments — in the pool, in the sea, under the sun. Press play and let the water do the rest.",
  "Séance — lagon": "Session — lagoon",
  "Flottaison — bassin privé": "Floating — private pool",
  "Immersion douce": "Gentle immersion",
  "La magie de l'eau": "The magic of water",
  "Séance — eau ouverte": "Session — open water",
  "Instants de séance": "Session moments",
  "Lâcher-prise": "Letting go",
  "Vagues et respiration": "Waves and breathing",
  "Séance partagée": "Shared session",
  "Dans le mouvement de l'eau": "In the movement of water",
  "Présence — main dans la main": "Presence — hand in hand",
  "L'eau en mouvement.": "Water in motion.",
  "Onze instants filmés — bassins privés, lagons et séances. Lancez la lecture, laissez l'eau faire le reste.": "Eleven filmed moments — private pools, lagoons and sessions. Press play and let the water do the rest.",
  "Stéphanie est l'invitée de « Dans l'Intimité du Vivant » — un épisode pour ouvrir la magie de l'eau, à l'ombre d'un arbre.": "Stéphanie is the guest of « Dans l'Intimité du Vivant » — an episode to open the magic of water, in the shade of a tree.",
  "Épisode 16 · Rencontre avec Stéphanie — La magie de l'eau": "Episode 16 · Meeting Stéphanie — The magic of water",
  "Écouter l'épisode sur Ausha": "Listen to the episode on Ausha",

  // landing
  "École Française de Janzu": "French School of Janzu",
  "Voyagez dans une eau chauffée à 33 °C avec le Janzu, un soin aquatique qui se reçoit et se transmet. Notre école vous forme, du premier module au master pro, au sein de trois magnifiques destinations océanes.":
    "Travel into water heated to 33 °C with Janzu, an aquatic therapy that is received and passed on. Our school trains you, from the first module to the master pro, across three magnificent ocean destinations.",
  "Découvrir la pratique": "Discover the practice",
  "modules — cursus & Master Pro": "modules — curriculum & Master Pro",
  "de cursus praticien certifié": "of certified practitioner curriculum",
  "eau des bassins privés": "water in the private pools",
  "destinations — France · Réunion · Maurice": "destinations — France · Reunion · Mauritius",
  "Prochaine session — 2026": "Next session — 2026",
  "Prêt·e à plonger ?": "Ready to dive in?",
  "Six places par module. Le parcours praticien commence par une seule décision : entrer dans l'eau.":
    "Six seats per module. The practitioner journey begins with a single decision: entering the water.",
  "Réserver ma place": "Book my spot",
  "École": "School",
  "certifiée Qualiopi": "Qualiopi certified",
  "Flottaison": "Floating",
  "Respiration": "Breathing",
  "Silence": "Silence",
  "Lâcher-prise": "Letting go",
  "Eau à 33 °C": "33 °C water",

  // formations
  "Les formations": "The trainings",
  "Quatre modules & un soin spécial": "Four modules & a special treatment",
  "Le calendrier 2027": "The 2027 calendar",
  "L'ensemble des formations de l'année — février et mars à La Réunion et à l'Île Maurice, puis Charente-Maritime d'avril à octobre. Cours privé possible, à vos dates.": "All of the year's trainings — February and March on Reunion Island and Mauritius, then Charente-Maritime from April to October. Private sessions possible, at your dates.",
  "En réservant, vous acceptez nos": "By booking, you accept our",
  "conditions générales de vente": "terms of sale",
  "CGV": "Terms of Sale",
  "J'ai lu et j'accepte les": "I have read and accept the",
  "Mentions légales": "Legal notice",
  "Tarif sur demande": "Price on request",
  "L'école française": "The French school",
  "de Janzu": "of Janzu",
  "Demander le tarif": "Ask for the price",
  "Contactez-nous pour organiser votre participation.": "Contact us to organise your participation.",
  "Mentions légales & CGU": "Legal notice & Terms of Use",
  "Mentions légales officielles de l'École Française de Janzu — OJANZU (texte repris de janzu.fr/mentions-légales).": "Official legal notice of the École Française de Janzu — OJANZU (text taken from janzu.fr/mentions-légales).",
  "Informations légales": "Legal information",
  "Conditions générales de vente": "Terms of Sale",
  "Un cursus progressif, de la surface à la maîtrise. Les modules durent cinq jours, le soin spécial Femmes Enceintes deux jours — en bassin privé chauffé à 33 °C, en groupe de 6 à 18 personnes.": "A progressive curriculum, from surface to mastery. Modules last five days, the special Pregnant Women treatment two days — in a private pool heated to 33 °C, in groups of 6 to 18 people.",
  "Un cursus progressif, de la surface à la maîtrise. Chaque module dure cinq jours, en bassin privé chauffé à 33 °C, en groupe réduit.":
    "A progressive curriculum, from the surface to mastery. Each module lasts five days, in a private pool heated to 33 °C, in a small group.",
  "Prochain module": "Next session",
  "Découvrir": "Discover",
  "L'expérience": "The experience",
  "Une eau à 33 °C, un silence absolu": "Water at 33 °C, absolute silence",
  "Eau chauffée à 33 °C": "Water heated to 33 °C",
  "Des bassins privés à température corporelle, pour des séances longues et profondes.":
    "Private pools at body temperature, for long and deep sessions.",
  "6 à 18 places": "6 to 18 places",
  "6 à 18 places restantes": "6 to 18 places left",
  "Groupe de 6 à 18 personnes": "Group of 6 to 18 people",
  "Un suivi individuel pendant toute la formation, entre pairs et auprès des formatrices et formateurs.":
    "Individual guidance throughout the training, among peers and with the trainers.",
  "Trois destinations": "Three destinations",
  "Charente-Maritime (La Rochelle), Île de La Réunion et Maurice — l'océan pour horizon.":
    "Charente-Maritime (La Rochelle), Reunion Island and Mauritius — the ocean as your horizon.",
  "Certifiée Qualiopi": "Qualiopi certified",
  "Le cursus praticien est accessible aux financements de la formation professionnelle.":
    "The practitioner curriculum is eligible for professional training funding.",
  "Le Janzu invite à redécouvrir un refuge intérieur de paix et de silence.":
    "Janzu invites you to rediscover an inner refuge of peace and silence.",

  // formations data
  "Initiation au soin aquatique": "Introduction to aquatic therapy",
  "Profondeur, souffle et submersion": "Depth, breath and submersion",
  "Accompagner, adapter, transmettre": "Support, adapt, pass on",
  "La maîtrise du langage corporel aquatique": "Mastering aquatic body language",
  "Le premier cercle. Vous entrez dans le langage du Janzu : la qualité de présence, l'écoute de l'eau et du corps, les mouvements fondateurs du soin. Une semaine pour installer les bases d'une pratique juste et bienveillante.":
    "The first circle. You enter the language of Janzu: quality of presence, listening to the water and the body, the founding movements of the practice. One week to lay the foundations of a fair and caring practice.",
  "Le cœur du cursus. Vous explorez les séquences en immersion, la submersion du receveur et la respiration partagée. Le corps apprend le rythme, la patience et la précision du geste juste.":
    "The heart of the curriculum. You explore submerged sequences, the receiver's submersion and shared breathing. The body learns rhythm, patience and the precision of the right gesture.",
  "L'art de l'adaptation. Vous apprenez à lire le langage corporel aquatique, à accueillir les émotions qui remontent et à adapter chaque séance à la personne accompagnée — y compris les publics spécifiques.":
    "The art of adaptation. You learn to read aquatic body language, to welcome the emotions that surface and to tailor each session to the person you support — including specific audiences.",
  "Le niveau expert. Une semaine pour affiner la posture, approfondir le décodage du langage corporel et accéder au titre de Praticien·ne Expert·e OJANZU.":
    "The expert level. One week to refine your posture, deepen body-language decoding and reach the title of OJANZU Expert Practitioner.",
  "Jour 1 · L'eau comme milieu thérapeutique, sécurité et écoute": "Day 1 · Water as a therapeutic environment, safety and listening",
  "Jour 2 · Les mouvements fondateurs du Janzu en surface": "Day 2 · The founding surface movements of Janzu",
  "Jour 3 · Rythme, souffle et qualité de présence": "Day 3 · Rhythm, breath and quality of presence",
  "Jour 4 · Séquences de soin complètes en surface": "Day 4 · Complete care sequences at the surface",
  "Jour 5 · Pratique supervisée, feedback et intégration": "Day 5 · Supervised practice, feedback and integration",
  "Jour 1 · Entrer en profondeur : posture du praticien": "Day 1 · Entering depth: the practitioner's posture",
  "Jour 2 · La submersion en douceur, clé par clé": "Day 2 · Gentle submersion, key by key",
  "Jour 3 · Respiration partagée et états de conscience": "Day 3 · Shared breathing and states of consciousness",
  "Jour 4 · Séquences d'immersion complètes": "Day 4 · Complete immersion sequences",
  "Jour 5 · Pratique supervisée et décodage fin": "Day 5 · Supervised practice and fine decoding",
  "Jour 1 · Lire le langage corporel dans l'eau": "Day 1 · Reading body language in the water",
  "Jour 2 · Accueillir et accompagner les émotions": "Day 2 · Welcoming and supporting emotions",
  "Jour 3 · Adapter la séance : femmes enceintes, peur de l'eau": "Day 3 · Tailoring the session: pregnant women, fear of water",
  "Jour 4 · Construire une séance sur mesure": "Day 4 · Building a tailored session",
  "Jour 5 · Pratique supervisée et éthique du soin": "Day 5 · Supervised practice and the ethics of care",
  "Jour 1 · Posture avancée et économie de geste": "Day 1 · Advanced posture and economy of movement",
  "Jour 2 · Décodage approfondi du langage corporel": "Day 2 · In-depth body-language decoding",
  "Jour 3 · Accompagner les libérations profondes": "Day 3 · Supporting deep releases",
  "Jour 4 · Transmission et pédagogie du Janzu": "Day 4 · Passing on and teaching Janzu",
  "Jour 5 · Évaluation, certification et suite du parcours": "Day 5 · Assessment, certification and next steps",
  "2026 · dates modulables": "2026 · flexible dates",
  "Près de La Rochelle — Charente-Maritime": "Near La Rochelle — Charente-Maritime",
  "Île de La Réunion": "Reunion Island",
  "Île Maurice": "Mauritius",
  "À confirmer": "To be confirmed",

  // philosophie
  "La philosophie": "The philosophy",
  "Développé à partir des techniques de Juan Villatoro Garza dans les années 1980, le Janzu se pratique dans une eau chaude où le corps n'a plus qu'à se confier. Un soin qui se transmet — et qui se reçoit d'abord.":
    "Developed from the techniques created by Juan Villatoro Garza in the 1980s, Janzu is practiced in warm water where the body simply surrenders. A therapy that is passed on — and first received.",
  "Porté par l'eau, le corps abandonne le contrôle : les tensions du dos, de la nuque et du mental se dissolvent naturellement, sans effort.":
    "Carried by the water, the body lets go of control: tensions in the back, neck and mind dissolve naturally, effortlessly.",
  "Le souffle devient le chef d'orchestre du soin. Il rythme les mouvements et guide le receveur vers un état de conscience profond.":
    "Breath becomes the conductor of the therapy. It sets the rhythm of the movements and guides the receiver into a deep state of consciousness.",
  "Au-delà du soin, le Janzu est une méditation en mouvement — un refuge intérieur de paix et de silence, pour qui le reçoit comme pour qui le donne.":
    "Beyond the therapy, Janzu is a meditation in motion — an inner refuge of peace and silence, for the receiver as much as for the giver.",
  "Découvrir les formations": "Explore the trainings",

  // école
  "L'école — OJANZU": "The school — OJANZU",
  "Une transmission authentique & certifiée": "An authentic & certified transmission",
  "Fondée par Stéphanie, l'École Française de Janzu transmet un soin né des techniques créées par Juan Villatoro Garza dans les années 1980. Le cursus progressif mène du premier contact avec l'eau au titre de Praticien·ne Expert·e, avec un enseignement en bassin privé chauffé à environ 33 °C.":
    "Founded by Stéphanie, the French School of Janzu passes on a therapy born from the techniques created by Juan Villatoro Garza in the 1980s. The progressive curriculum leads from the first contact with water to the title of Expert Practitioner, taught in a private pool heated to about 33 °C.",
  "Certifiée Qualiopi, l'école propose des sessions en Charente-Maritime, sur l'île de La Réunion et à Maurice, avec des dates modulables pour s'adapter à votre parcours.":
    "Qualiopi certified, the school runs sessions in Charente-Maritime, on Reunion Island and in Mauritius, with flexible dates to fit your journey.",
  "Avoir reçu au moins une séance de Janzu": "Have received at least one Janzu session",
  "18 ans minimum": "18 years minimum",
  "Être apte à se mouvoir librement": "Be able to move freely",
  "Notre certification Qualiopi": "Our Qualiopi certification",
  "Voir les formations": "View the trainings",

  // témoignages
  "Paroles de la communauté": "Voices from the community",
  "Les retours de celles et ceux qui ont suivi le cursus praticien OJANZU — et le reportage TF1 qui leur est consacré.":
    "Feedback from those who completed the OJANZU practitioner curriculum — and the TF1 report dedicated to them.",
  "J'ai appris à écouter l'eau autant que les corps qu'elle porte. Ma façon de faire soin a changé.":
    "I learned to listen to the water as much as the bodies it carries. My way of giving care has changed.",
  "Praticienne — La Rochelle": "Practitioner — La Rochelle",
  "Trois modules, trois océans. La progression est douce, exigeante et profondément humaine.":
    "Three modules, three oceans. The progression is gentle, demanding and deeply human.",
  "Praticien — La Réunion": "Practitioner — Reunion Island",
  "Je suis arrivée avec la peur de l'eau. Je repars avec une pratique qui me ressemble.":
    "I arrived afraid of water. I leave with a practice that feels like me.",
  "Praticienne — Maurice": "Practitioner — Mauritius",
  "Envie de voir leurs visages ? Le reportage TF1 vous attend dans": "Want to see their faces? The TF1 report awaits you in",
  "l'onglet Presse": "the Press tab",
  "Retrouvez tous nos avis Google": "Read all our Google reviews",
  "La confiance de nos stagiaires se lit aussi dans leurs avis Google — cliquez pour les découvrir.":
    "Our trainees' trust also shows in their Google reviews — click to read them.",

  // presse
  "Presse — Reportage TF1": "Press — TF1 report",
  "TF1 s'est intéressé aux activités de l'École française de JANZU® (Stéphanie Vautey). En est sorti un magnifique reportage témoignage « Les secrets de l'eau guérisseuse », réalisé par Laurent Fléchaire, avec David Amouzegh.":
    "TF1 took an interest in the French School of JANZU® (Stéphanie Vautey). The result is a wonderful testimonial report, \"The secrets of healing water\", directed by Laurent Fléchaire, with David Amouzegh.",
  "Voir le reportage TF1": "Watch the TF1 report",
  "Lire l'article du Point": "Read the Le Point article",
  "Ils témoignent en vidéo": "Video testimonials",
  "Reportage TF1 · témoignages de stagiaires (David Amouzegh) —": "TF1 report · trainees' testimonials (David Amouzegh) —",
  "ouvrir sur YouTube": "voir sur janzu.fr",
  "Reportage TF1 · YouTube": "TF1 report · janzu.fr",
  "voir sur janzu.fr": "view on janzu.fr",
  "Vidéo · YouTube": "Video · YouTube",
  "Ils parlent du Janzu": "They talk about Janzu",

  // certification
  "Une école certifiée.": "A certified school.",
  "Certification qualité délivrée au titre des actions de formation.": "Quality certification issued for training activities.",
  "Qu'est-ce que Qualiopi ?": "What is Qualiopi?",
  "La marque de certification qualité délivrée par l'État français aux organismes de formation dont les processus sont audités selon le Référentiel National Qualité.":
    "The quality certification mark issued by the French State to training organisations whose processes are audited against the National Quality Framework.",
  "Ce que ça garantit": "What it guarantees",
  "Un fonctionnement audité : accueil des stagiaires, adaptation des séances, suivi pédagogique, recueil des appréciations et amélioration continue.":
    "Audited operations: trainee welcome, session adaptation, educational monitoring, feedback collection and continuous improvement.",
  "Ce que ça débloque": "What it unlocks",
  "L'accès aux financements de la formation professionnelle — le cursus praticien OJANZU est finançable par les opérateurs de compétences.":
    "Access to professional training funding — the OJANZU practitioner curriculum can be funded by skills operators (OPCO).",
  "Notre engagement": "Our commitment",
  "Une transmission exigeante et humaine, contrôlée de l'intérieur comme de l'extérieur, pour des praticien·ne·s sûrs de leur pratique.":
    "Demanding, human teaching — checked from inside and out — so practitioners can trust their practice.",
  "Voir les formations finançables": "See fundable trainings",
  "Poser une question": "Ask a question",

  // contact
  "Parlons de votre parcours.": "Let's talk about your journey.",
  "Une question sur les modules, les dates ou le financement ? Stéphanie vous répond personnellement.":
    "A question about modules, dates or funding? Stéphanie will personally get back to you.",
  "Directrice & Formatrice": "Director & Trainer",
  "Écrivez-nous": "Write to us",
  "Votre nom": "Your name",
  "Votre email": "Your email",
  "Téléphone (optionnel)": "Phone (optional)",
  "Votre message — modules, dates, financement…": "Your message — modules, dates, funding…",
  "Envoyer ma demande": "Send my request",
  "Envoi…": "Sending…",
  "Message envoyé ! Stéphanie vous répondra très vite — un accusé de réception arrive dans votre boîte mail.":
    "Message sent! Stéphanie will get back to you very soon — a confirmation is on its way to your inbox.",

  // faq
  "Questions fréquentes": "Frequently asked questions",
  "Tout savoir avant de plonger": "Everything you need to know before diving in",
  "Faut-il déjà être à l'aise dans l'eau ?": "Do I already need to be comfortable in water?",
  "Trois prérequis seulement : avoir reçu au moins une séance de Janzu, avoir 18 ans minimum et être physiquement apte à se mouvoir librement. La crainte de l'eau ne bloque pas la formation — des spécialisations lui sont même dédiées.":
    "Only three prerequisites: having received at least one Janzu session, being 18 or older, and being physically able to move freely. Fear of water does not block the training — dedicated specialisations even exist for it.",
  "La formation est-elle finançable ?": "Is the training fundable?",
  "L'école est certifiée Qualiopi : le cursus praticien ouvre l'accès aux financements de la formation professionnelle. Contactez-nous pour constituer votre dossier.":
    "The school is Qualiopi certified: the practitioner curriculum opens access to professional training funding. Contact us to build your application.",
  "En combien de temps devient-on praticien·ne ?": "How long does it take to become a practitioner?",
  "Le cursus praticien se compose de trois modules de cinq jours chacun — Janzu I Surface, Janzu II Immersion, Janzu III Accompagnement — plus un temps de pratique personnelle entre les modules. Le Master Pro porte le parcours au niveau Praticien Expert.":
    "The practitioner curriculum consists of three five-day modules — Janzu I Surface, Janzu II Immersion, Janzu III Support — plus personal practice time between modules. The Master Pro takes you to Expert Practitioner level.",
  "Où se déroulent les formations ?": "Where do the trainings take place?",
  "Dans des bassins privés chauffés à environ 33 °C, principalement en Charente-Maritime (La Rochelle), et également sur l'île de La Réunion et à Maurice.":
    "In private pools heated to about 33 °C, mainly in Charente-Maritime (La Rochelle), and also on Reunion Island and in Mauritius.",
  "Une autre question ?": "Another question?",
  "Stéphanie vous répond personnellement — par téléphone ou via le formulaire.":
    "Stéphanie will answer personally — by phone or through the form.",
  "Nous contacter": "Contact us",

  // galerie
  "Galerie OJANZU": "OJANZU Gallery",
  "L'eau en grand.": "Water, life size.",
  "Instants de séances, bassins et destinations — cliquez sur une photo pour la contempler en plein écran.":
    "Session moments, pools and destinations — click a photo to view it full screen.",
  "Nageuse en surface, eau turquoise": "Swimmer at the surface, turquoise water",
  "Séance de Janzu à deux en piscine": "Two-person Janzu session in a pool",
  "Visage émergé, souffle profond": "Emerged face, deep breath",
  "Le bassin de formation": "The training pool",
  "Soin aquatique vu du ciel": "Aquatic therapy from above",
  "Flottaison en bassin intérieur": "Floating in an indoor pool",
  "Séance au bord de l'océan": "Session by the ocean",
  "Front contre front dans l'eau": "Forehead to forehead in the water",
  "Lâcher-prise, bras ouverts": "Letting go, arms open",
  "Accompagnement en piscine": "Support in the pool",
  "L'étoile — vue du dessus": "The star — top view",
  "Premières découvertes en famille": "First discoveries as a family",
  "L'eau et le sable": "Water and sand",
  "Groupe en formation": "Group in training",
  "Surface et lumière": "Surface and light",
  "Joie de l'eau partagée": "Shared joy of water",
  "La praticienne au travail": "The practitioner at work",
  "Mouvements fondateurs": "Founding movements",

  // auth
  "Bon retour dans l'eau.": "Welcome back to the water.",
  "Connectez-vous pour retrouver votre progression et vos sessions.": "Log in to see your progress and sessions.",
  "Entrer dans l'eau.": "Step into the water.",
  "Créez votre compte membre pour réserver vos modules de formation.": "Create your member account to book your training modules.",
  "Inscription": "Sign up",
  "Email": "Email",
  "Mot de passe (8 caractères min.)": "Password (8 characters min.)",
  "Se connecter": "Log in",
  "Créer mon compte": "Create my account",
  "L'eau porte, le silence transforme.": "Water carries, silence transforms.",
  "Retour au site": "Back to the site",

  // payment
  "Votre place est réservée.": "Your spot is booked.",
  "Le paiement du module est confirmé. Retrouvez votre session et votre progression dans votre espace praticien·ne.":
    "The module payment is confirmed. Find your session and progress in your practitioner space.",
  "Ouvrir mon espace": "Open my space",
  "Confirmation en cours…": "Confirmation in progress…",
  "Nous validons votre paiement avec Stripe. Cela ne prend qu'un instant.":
    "We are confirming your payment with Stripe. It only takes a moment.",
  "Paiement interrompu": "Payment interrupted",
  "Aucun montant n'a été débité. Votre place vous attend — vous pouvez reprendre la réservation à tout moment.":
    "No amount was charged. Your spot is waiting — you can resume booking at any time.",
  "Revoir les formations": "Back to the trainings",

  // dashboard
  "Mon espace praticien·ne": "My practitioner space",
  "Votre progression dans le cursus, vos sessions réservées et la communauté OJANZU.":
    "Your curriculum progress, your booked sessions and the OJANZU community.",
  "Heures validées": "Hours validated",
  "Modules complétés": "Modules completed",
  "Sessions réservées": "Booked sessions",
  "Progression du cursus": "Curriculum progress",
  "Module validé": "Module validated",
  "Session réservée — à valider après le stage": "Session booked — validate after the training",
  "Pas encore réservé": "Not booked yet",
  "Marquer comme validée": "Mark as validated",
  "Réserver": "Book",
  "La communauté": "The community",
  "Le fil des praticien·ne·s OJANZU — partages de séances, ressentis, questions.":
    "The OJANZU practitioners' feed — session shares, experiences, questions.",
  "Partagez votre expérience de l'eau…": "Share your experience of the water…",
  "Publier": "Publish",

  // formation detail
  "Toutes les formations": "All trainings",
  "Cette formation n'existe plus.": "This training no longer exists.",
  "Module": "Module",
  "jours": "days",
  "places": "seats",
  "places restantes": "seats left",
  "Le programme": "The programme",
  "Prérequis": "Prerequisites",
  "Tarif du module": "Module fee",
  "Choisissez votre session": "Choose your session",
  "Réserver — paiement sécurisé": "Book — secure payment",
  "Se connecter pour réserver": "Log in to book",
  "Paiement Stripe · Certifiée Qualiopi": "Stripe payment · Qualiopi certified",
  "Le silence a une profondeur.": "Silence has depth.",
};

export function makeTr(lang) {
  return (fr) => (lang === "en" && EN[fr]) || fr;
}

const FORMATION_EN = {
  "Janzu I — Surface": "Janzu I — Surface",
  "Janzu II — Immersion": "Janzu II — Immersion",
  "Janzu III — Accompagnement": "Janzu III — Support",
  "Master Pro — Praticien Expert": "Master Pro — Expert Practitioner",
};

export function trFormation(f, tr) {
  // Only apply EN title mapping when tr actually translates (i.e., EN mode).
  // In FR mode, tr returns the key unchanged, so a probe string will equal itself.
  const isEn = tr("Formations") !== "Formations";
  return {
    ...f,
    title: isEn ? (FORMATION_EN[f.title] || f.title) : f.title,
    subtitle: tr(f.subtitle),
    description: tr(f.description),
    curriculum: (f.curriculum || []).map((c) => tr(c)),
    sessions: (f.sessions || []).map((s) => ({
      ...s,
      periode: tr(s.periode),
      lieu: tr(s.lieu),
    })),
  };
}
